export default {
  appletCarouselApi: {
      //轮播图配置
      config: {
        getBaseConfig: 'api/appletCarouselApi/getBaseConfig',
        updateConfig: 'api/appletCarouselApi/updateConfig'
      },
      chart: {
        list: 'api/appletCarouselApi/list',
        del: 'api/appletCarouselApi/del',
        saveOrUpdate: 'api/appletCarouselApi/saveOrUpdate'
      }

  }
}
